/* eslint-disable */
/* eslint-disable no-unused-vars */
import React, {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useState,
} from 'react';
import { IconContext } from 'react-icons';
import { useLocation } from 'react-router-dom';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import useRolePermission from 'src/hooks/useRolePermission';
import { ReactComponent as SupportDeskIcon } from 'src/assets/support_desk.svg';
import { useQuery } from '@tanstack/react-query';
import UserService from 'src/services/user.service';
import LogoBlue from '../../assets/logo_pride_mini.svg';
import { ReactComponent as LogoText } from '../../assets/logo_text.svg';

import { ReactComponent as Dashboard } from '../../assets/dashboard.svg';
import { ReactComponent as HrProfile } from '../../assets/person.svg';
import { ReactComponent as PayHistory } from '../../assets/suitcase.svg';
import { ReactComponent as Reports } from '../../assets/reports_icn.svg';
import { ReactComponent as Settings } from '../../assets/settings_icn.svg';
import { ReactComponent as HelpFaq } from '../../assets/Help.svg';
import { ReactComponent as BenefitIcn } from '../../assets/benefits_icn.svg';
import { ReactComponent as YearEndForm } from '../../assets/year_end_forms_icn.svg';
import { ReactComponent as InvoiceBillProcess } from '../../assets/invoice-bill-process-ic.svg';
import { ReactComponent as InvoicePayProcess } from '../../assets/invoice-pay-process-ic.svg';
import { ReactComponent as NotificationsBell } from '../../assets/notification-bell.svg';
import { ReactComponent as SupportDeskNewIcon } from '../../assets/Support Ticket.svg';
import { ReactComponent as LeaveIcon } from '../../assets/Leave Application Icon.svg';
import { ReactComponent as Logout } from '../../assets/logout.svg';
import { ReactComponent as InvoiceNewIcon } from '../../assets/invoice.svg';
import {
  NavMenu,
  LogoContainer,
  LogoImg,
  NavMenuItems,
  NavText,
  NavTextLink,
  NavTextTitle,
  MainContainer,
  NotificationWrapper,
  NavTextWithoutLink,
} from './styles';
import Notifications from '../../modules/notifications';
import logoutService from '../../services/logout.service';
import { ApplicationCtx } from '../..';

import { CompanySelect } from '../company-select';
import CompanyService from 'src/services/company.services';

export enum RolePermission {
  ADMIN = 'admin',
  SUPER_ADMIN = 'super_admin',
  EXTERNAL_ADMIN = 'external_admin',
}

export const SidebarData = [
  // {
  //   title: 'Home',
  //   path: '/dashboard',
  //   icon: <Dashboard />,
  //   permissions: Permission.HOME,
  //   backgroundColor: '#f3f4f8',
  // },
  {
    title: 'Employees',
    path: '/employee-management',
    icon: <HrProfile />,
    permissions: [RolePermission.ADMIN, RolePermission.EXTERNAL_ADMIN],
    backgroundColor: '#f3f4f8',
    adminPermissionId: 'admin_employees',
  },
  {
    title: 'Pay History',
    path: '/pay-history',
    icon: <PayHistory />,
    permissions: [RolePermission.ADMIN, RolePermission.SUPER_ADMIN],
    backgroundColor: '#f3f4f8',
    adminPermissionId: 'admin_pay_history',
  },
  {
    title: 'Year-End Forms',
    path: '/year-end-forms',
    icon: <YearEndForm />,
    permissions: [RolePermission.ADMIN],
    backgroundColor: '#f3f4f8',
    adminPermissionId: 'admin_year_end_forms',
  },
  {
    title: 'Benefits',
    path: '/benefits',
    icon: <BenefitIcn />,
    permissions: [RolePermission.SUPER_ADMIN],
    backgroundColor: '#f3f4f8',
    adminPermissionId: 'admin_benefits',
  },
  {
    title: 'Reports',
    path: '/reports',
    icon: <Reports />,
    permissions: [RolePermission.SUPER_ADMIN],
    backgroundColor: '#f3f4f8',
    adminPermissionId: 'admin_reports',
  },
  {
    title: 'Workflow',
    path: '/workflow',
    icon: <YearEndForm />,
    permissions: [RolePermission.ADMIN],
    backgroundColor: '#f3f4f8',
    adminPermissionId: 'admin_employees',
  },
  {
    title: 'Bill Process Invoice',
    path: '/bill-process-invoices',
    icon: <InvoiceBillProcess width={20} height={20} />,
    permissions: [RolePermission.ADMIN],
    backgroundColor: '#f3f4f8',
    adminPermissionId: 'admin_bill_process',
  },
  {
    title: 'Pay Process Invoice',
    path: '/pay-process-invoices',
    icon: <InvoicePayProcess width={20} height={20} />,
    permissions: [RolePermission.ADMIN],
    backgroundColor: '#f3f4f8',
    adminPermissionId: 'admin_pay_process',
  },
  {
    title: 'Bill Process Expense',
    path: '/bill-process-expense',
    icon: <InvoiceBillProcess width={20} height={20} />,
    permissions: [RolePermission.ADMIN],
    backgroundColor: '#f3f4f8',
    adminPermissionId: 'admin_bill_process',
  },
  {
    title: 'Pay Process Expense',
    path: '/pay-process-expense',
    icon: <InvoiceBillProcess width={20} height={20} />,
    permissions: [RolePermission.ADMIN],
    backgroundColor: '#f3f4f8',
    adminPermissionId: 'admin_bill_process',
  },
  // {
  //   title: 'Batch',
  //   path: '/pay-process-expense',
  //   icon: <InvoiceBillProcess width={20} height={20} />,
  //   permissions: [RolePermission.ADMIN],
  //   backgroundColor: '#f3f4f8',
  //   adminPermissionId: 'admin_bill_process',
  // },
];

export const ApplicationPaths = [
  {
    title: 'DirectDeposit',
    path: '/direct-deposit',
    backgroundColor: '#f3f4f8',
  },
  {
    path: '/benefits/open-enrollment',
    title: 'Open Enrollment Event',
    backgroundColor: '#f3f4f8',
  },
  {
    path: '/settings',
    title: 'Settings',
    backgroundColor: '#f3f4f8',
  },
  {
    path: '/support-desk',
    icon: <BenefitIcn />,
    title: 'SupportDesk',
    backgroundColor: '#f3f4f8',
  },
  {
    path: '/faq',
    icon: <BenefitIcn />,
    title: 'Faq',
    backgroundColor: '#f3f4f8',
  },
  {
    path: '/invoices',
    icon: <InvoiceNewIcon />,
    title: 'Invoice',
    backgroundColor: '#f3f4f8',
  },
  {
    path: '/expenses',
    icon: <InvoiceNewIcon />,
    title: 'Expense',
    backgroundColor: '#f3f4f8',
  },
  {
    path: '/leave',
    title: 'LeaveModule',
    backgroundColor: '#f3f4f8',
  },
];

export const SideBar: React.FC = ({ children }) => {
  const [sidebar, setSidebar] = useState(false);
  const [notification, setNotification] = useState(false);
  const { isFetching, data: usersAccess } = useQuery(['admin/modules'], async () => {
    const result = await UserService.getAdminModules();
    return result;
  });

  const [usersAccessSave, setUsersAccessSave] = useLocalStorage('userAccessAdmin', null);

  useEffect(() => {
    if (usersAccess?.data) {
      setUsersAccessSave(usersAccess.data);
    }
  }, [usersAccess?.data, setUsersAccessSave]);
  // eslint-disable-next-line no-unused-vars

  const { data: workflow } = useQuery({
    queryKey: ['users/workflow/id'],
    queryFn: () => CompanyService.getWorkflowById(''),
    enabled: true,
  });
  const { ctxState, ctxUpdate } = useContext(ApplicationCtx);
  const location = useLocation();

  const { hasRolePermission } = useRolePermission();

  const applyBackgroundByPath = (path: string): void => {
    const paths = [...SidebarData, ...ApplicationPaths];
    const data: typeof SidebarData | typeof ApplicationPaths = paths.filter(item => item.path === path);

    const newColor = data.length ? data[0].backgroundColor : '#fff';

    ctxUpdate({ ...ctxState, backgroundColor: newColor });
  };

  useEffect(() => {
    applyBackgroundByPath(location.pathname);
  }, [location]);

  const handleLogout = () => {
    logoutService.logout();
  };

  const handleSidebar = () => {
    setSidebar(ps => !ps);
  };

  return (
    <>
      <IconContext.Provider value={{ size: '25px' }}>
        <NavMenu active={sidebar} onMouseEnter={handleSidebar} onMouseLeave={handleSidebar}>
          <NavMenuItems>
            <LogoContainer>
              <LogoImg src={LogoBlue} />
              <LogoText />
            </LogoContainer>

            <CompanySelect isOpen={sidebar} />
            {SidebarData.filter(item => {
              const isWorkflow = item.title === 'Workflow';

              if (isWorkflow) {
                const workflowData = workflow?.data;
                return Array.isArray(workflowData) && workflowData.length > 0;
              }

              if (!usersAccess?.data) return false;

              const userPermissions = usersAccess.data.map((perm: any) => perm.adminPermissionId);
              return userPermissions.includes(item.adminPermissionId);
            }).map((item, index) => (
              <NavText key={index}>
                <NavTextLink to={item.path} expanded={sidebar ? 1 : 0}>
                  {item.icon}
                  <NavTextTitle>{item.title}</NavTextTitle>
                </NavTextLink>
              </NavText>
            ))}
          </NavMenuItems>
          <NavMenuItems>
            {usersAccess?.data?.some((perm: any) => perm.adminPermissionId === 'admin_support_desk') && (
              <NavText>
                <NavTextLink to="/support-desk" expanded={sidebar ? 1 : 0}>
                  <SupportDeskNewIcon />
                  <NavTextTitle>Support Desk</NavTextTitle>
                </NavTextLink>
              </NavText>
            )}

            {hasRolePermission(RolePermission.ADMIN) && (
              <NavText>
                <NavTextLink to="/invoices" expanded={sidebar ? 1 : 0}>
                  <InvoiceNewIcon />
                  <NavTextTitle>Invoice</NavTextTitle>
                </NavTextLink>
              </NavText>
            )}

            {hasRolePermission(RolePermission.ADMIN) && (
              <NavText>
                <NavTextLink to="/expenses" expanded={sidebar ? 1 : 0}>
                  <InvoiceNewIcon />
                  <NavTextTitle>Expense</NavTextTitle>
                </NavTextLink>
              </NavText>
            )}

            {hasRolePermission(RolePermission.SUPER_ADMIN) && (
              <NavText>
                <NavTextLink to="/faq" expanded={sidebar ? 1 : 0}>
                  <HelpFaq />
                  <NavTextTitle>FAQ</NavTextTitle>
                </NavTextLink>
              </NavText>
            )}

            {usersAccess?.data?.some((perm: any) => perm.adminPermissionId === 'admin_leave') && (
              <NavText>
                <NavTextLink to="/leave" expanded={sidebar ? 1 : 0}>
                  <LeaveIcon />
                  <NavTextTitle>Leave</NavTextTitle>
                </NavTextLink>
              </NavText>
            )}
            {/* {hasRolePermission(RolePermission.SUPER_ADMIN) && ( */}
            <NavText>
              <NavTextLink to="/clientmileage" expanded={sidebar ? 1 : 0}>
                <Settings />
                <NavTextTitle>Client & Mileage</NavTextTitle>
              </NavTextLink>
            </NavText>
            {/* )} */}

            {hasRolePermission(RolePermission.SUPER_ADMIN) && (
              <NavText>
                <NavTextLink to="/settings" expanded={sidebar ? 1 : 0}>
                  <Settings />
                  <NavTextTitle>Settings</NavTextTitle>
                </NavTextLink>
              </NavText>
            )}
            <NavText
              onClick={() => {
                setNotification(!notification);
              }}
            >
              <NotificationWrapper expanded={sidebar ? 1 : 0}>
                <NotificationsBell />
                <NavTextTitle>Notifications</NavTextTitle>
              </NotificationWrapper>
            </NavText>
            <NavText onClick={handleLogout}>
              <NavTextWithoutLink expanded={sidebar ? 1 : 0}>
                <Logout />
                <NavTextTitle>Logout</NavTextTitle>
              </NavTextWithoutLink>
            </NavText>
          </NavMenuItems>
        </NavMenu>
      </IconContext.Provider>

      <MainContainer backgroundColor={ctxState.backgroundColor}>{children}</MainContainer>

      <Notifications open={notification} />
    </>
  );
};
